import { ComponentEntity } from "@backstage/catalog-model";
import { IconButton } from "@material-ui/core";
import React from 'react';
import { DevopsPipelinesIcon, DevopsTestLabIcon, GitIcon } from "../../icons";
import { DevopsMetadataLinks, useDevopsMetaLinks } from "./DevopsTypeMetadataReader";

export const DevopsComponentLinks = (props: { component: ComponentEntity }) => {

    const { metadata } = props.component;

    const links: DevopsMetadataLinks = useDevopsMetaLinks(metadata);

    return (<>
        {links.pipelinesAutomatedTests && (
            <IconButton href={links.pipelinesAutomatedTests} target="_blank">
                <DevopsTestLabIcon />
            </IconButton>
        )}
        {links.pipelines && (
            <IconButton href={links.pipelines} target="_blank">
                <DevopsPipelinesIcon />
            </IconButton>
        )}
        {links.repository && (
            <IconButton href={links.repository} target="_blank">
                <GitIcon />
            </IconButton>
        )}
    </>);
}

